import { render, staticRenderFns } from "./HospitalizationDetail.vue?vue&type=template&id=0d8638b4"
import script from "./HospitalizationDetail.vue?vue&type=script&lang=js"
export * from "./HospitalizationDetail.vue?vue&type=script&lang=js"
import style0 from "./HospitalizationDetail.vue?vue&type=style&index=0&id=0d8638b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports